const melanomaCriteria=[
{symptom:"changeInSize",
displayAs:"Change in size",
points:2
},

{symptom:"irregularShape",
displayAs:"Irregular shape",
points:2
},

{symptom:"irregularColour",
displayAs:"Irregular colour",
points:2
},

{symptom:"largestDiameter",
displayAs:"Largest diameter 7 mm or more",
points:1
},

{symptom:"inflammation",
displayAs:"Inflammation",
points:1
},

{symptom:"oozing",
displayAs:"Oozing",
points:1
},

{symptom:"ChangeSensation",
displayAs:"Change in sensation",
points:1
}
]

export default melanomaCriteria















